import { Component } from '@angular/core';
import { SelectOption } from './shared/components/atoms/select/model/option.interface';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ac-new-client-process-BR';

  options: SelectOption[] = [
    {value: 1, text: 'test1'},
    {value: 2, text: 'test2'}
    
  ]
}
